module.exports = __webpack_public_path__ + "media/D7.67ab9dc6.wav";